import styled from 'styled-components';

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
`;
